import instance from '@/utils/instance';

//订单列表
export function postConsumerOrderList(params) {
	return instance({
		url: `/webL_api/consumer/order/list?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
		method: 'post',
		data: params
	});
}

//创建订单
export function postConsumerOrderNew(params) {
	return instance({
		url: `/webL_api/consumer/order/new`,
		method: 'post',
		data: params
	});
}

//取消订单
export function getConsumerOrderCancel(params) {
	return instance({
		url: `/webL_api/consumer/order/cancel/${params}`,
		method: 'get'
	});
}

//订单明细
export function getConsumerOrderInfo(params) {
	return instance({
		url: `/webL_api/consumer/order/info/${params}`,
		method: 'get'
	});
}

//客户收货
export function getConsumerOrderReceipt(params) {
	return instance({
		url: `/webL_api/consumer/order/receipt/${params}`,
		method: 'get'
	});
}

//修改收货地址
export function getConsumerOrderAddress(params) {
	return instance({
		url: `/webL_api/consumer/order/address/${params.orderNo}/${params.addressId}`,
		method: 'get'
	});
}

//申请退换货
export function postConsumerOrderRefund(params) {
	return instance({
		url: `/webL_api/consumer/order/refund`,
		method: 'post',
		data: params
	});
}

//获取标准标识
export function getConsumerOrderQueryStandard(params) {
	return instance({
		url: `/webL_api/consumer/order/queryStandard/${params}`,
		method: 'get',
	});
}

//获取退换货理由
export function getConsumerOrderRefundReason() {
	return instance({
		url: `/webL_api/consumer/order/getRefundType`,
		method: 'get',
	});
}

//获取订单发票
export function getConsumerOrderInvoice(params) {
	return instance({
		url: `/webL_api/consumer/order/queryInvoice/${params}`,
		method: 'get',
	});
}

//申请开票
export function postConsumerOrderInvoice(params) {
	return instance({
		url: `/webL_api/consumer/order/createInvoice`,
		method: 'post',
		data: params
	});
}

//更换支付方式
export function postConsumerOrderChangePayType(params) {
	return instance({
		url: `/webL_api/consumer/order/changePayType`,
		method: 'post',
		data: params
	});
}

//预计算运费
export function postConsumerOrderShippingCost(params) {
	return instance({
		url: `/webL_api/consumer/order/shippingCost`,
		method: 'post',
		data: params
	});
}

//防伪验证
export function getConsumerOrderVerifyAuth(params) {
	return instance({
		url: `/webL_api/consumer/order/verifyAuth`,
		method: 'post',
		data: params
	});
}

//兑换邀请码
export function getConsumerOrderExchangeInviteCode(params) {
	return instance({
		url: `/webL_api/consumer/member/exchange/${params}`,
		method: 'get'
	});
}

//查询VIP兑换码信息
export function getConsumerOrderQueryVipCode(params) {
	return instance({
		url: `/webL_api/consumer/member/queryExchange/${params}`,
		method: 'get'
	});
}

//正版说明查询 - 企业已购电子标准清单
export function getConsumerOrderVerify(params) {
	return instance({
		url: `/webL_api/corporate/acc/verifyBuyInfo?verifyCode=${params}`,
		method: 'post'
	});
}


